import React from 'react'

const Chevron = ({ title, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <title>{title}</title>
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#1557BF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.35"
      d="M6 13l4-4-4-4"
    />
  </svg>
)

export default Chevron
